import axios from 'axios';

import { LOANS_API_ENDPOINT } from 'constants/api';

const loansAPI = axios.create({
  baseURL: LOANS_API_ENDPOINT,
});

export default loansAPI;
